import { auth, persistence } from "@/firebase";

function signIn(email, password) {
  return new Promise((resolve, reject) => {
    auth
      .setPersistence(persistence)
      .then(() => {
        auth
          .signInWithEmailAndPassword(email, password)
          .then(userCredential => {
            resolve(userCredential.user);
          })
          .catch(error => {
            reject(error);
          });
      })
      .catch(error => {
        reject(error);
      });
  });
}

function signOut() {
  return new Promise((resolve, reject) => {
    auth
      .signOut()
      .then(() => {
        resolve();
      })
      .catch(error => {
        reject(error);
      });
  });
}

function sendPasswordResetEmail(email) {
  return new Promise((resolve, reject) => {
    auth
      .sendPasswordResetEmail(email)
      .then(() => {
        resolve();
      })
      .catch(error => {
        reject(error);
      });
  });
}

function changePassword(newPassword) {
  return new Promise((resolve, reject) => {
    const user = auth.currentUser;
    user
      .updatePassword(newPassword)
      .then(() => {
        resolve();
      })
      .catch(error => {
        reject(error);
      });
  });
}

function changeEmail(newEmail) {
  return new Promise((resolve, reject) => {
    const user = auth.currentUser;
    user
      .updateEmail(newEmail)
      .then(() => {
        resolve();
      })
      .catch(error => {
        reject(error);
      });
  });
}

function confirmPasswordReset(code, newPassword) {
  return new Promise((resolve, reject) => {
    auth
      .confirmPasswordReset(code, newPassword)
      .then(() => {
        resolve();
      })
      .catch(error => {
        reject(error);
      });
  });
}

export default {
  signIn,
  signOut,
  sendPasswordResetEmail,
  changePassword,
  changeEmail,
  confirmPasswordReset
};
